import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propChildren, propId, propShape, } from '../../../../../../../helpers/custom-prop-types';
import PlainInput from '../../../../../../Ui/Common/PlainInput';
const OrderInputRadio = (props) => {
    const { checked, input, meta, rightComponent, setValue } = props;
    return (_jsxs("label", Object.assign({ className: 'radio_label' }, { children: [_jsx(PlainInput, { checked: checked, className: '', input: input, meta: meta, type: 'radio', value: setValue }), _jsx("i", {}), rightComponent] })));
};
OrderInputRadio.propTypes = {
    checked: propBool().isRequired,
    input: propShape().isRequired,
    meta: propShape().isRequired,
    rightComponent: propChildren().isRequired,
    setValue: propId().isRequired,
};
export default OrderInputRadio;
